import { AfterViewInit, Directive, ElementRef, EventEmitter, Output } from '@angular/core';

import { CorePlatformService } from '@core/data-providers/platform/platform.service';

@Directive({
    selector: '[deferLoad]',
})
export class DeferLoadDirective implements AfterViewInit {
    @Output() public readonly deferLoad: EventEmitter<any> = new EventEmitter();

    private _intersectionObserver?: IntersectionObserver;

    constructor(
        private readonly _element: ElementRef,
        private readonly platformService: CorePlatformService,
    ) {}

    public ngAfterViewInit(): void {
        if (this.platformService.isBrowser()) {
            this._intersectionObserver = new IntersectionObserver(entries => {
                this.checkForIntersection(entries);
            }, {
                rootMargin: '10px',
            });
            this._intersectionObserver.observe(this._element.nativeElement as Element);
        } else {
            this.deferLoad.emit();
        }
    }

    private readonly checkForIntersection = (entries: IntersectionObserverEntry[]): void => {
        entries.forEach((entry: IntersectionObserverEntry) => {
            if (this.checkIfIntersecting(entry)) {
                this.deferLoad.emit();
                this._intersectionObserver.unobserve(this._element.nativeElement as Element);
                this._intersectionObserver.disconnect();
            }
        });
    };

    private checkIfIntersecting(entry: IntersectionObserverEntry): boolean {
        return (entry as any).isIntersecting && entry.target === this._element.nativeElement;
    }
}
